<div class="elux-toast-container">
  <div [class]="'elux-toast ' + toast.type" *ngFor="let toast of toasts">
    <lib-elux-icon [icon]="getToastIcon(toast.type)" [color]="getToastColor(toast.type)" size="24" sizeType="px" />

    <span class="message" [innerHTML]="toast.message"></span>

    <button
      type="button"
      class="toast-close-button c-pointer"
      (click)="close(toast.id)"
      aria-label="Fechar notificação"
    >
      <lib-elux-icon [icon]="'Close.svg'" [color]="getToastColor(toast.type)" size="24" sizeType="px" />
    </button>
  </div>
</div>
